import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M9.5 4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v6h3.265a.5.5 0 0 1 .347.86l-5.747 5.56a.5.5 0 0 1-.694.002L5.894 10.86A.5.5 0 0 1 6.24 10H9.5V4zM20 19H4v2h16v-2z" }));
export default createSvgIcon(iconPath, "Downloads");
//# sourceMappingURL=DownloadsIcon.js.map